import Head from "next/head";
import dynamic from "next/dynamic";
import { useEffect, useState } from "react";
import { useRouter } from "next/router";
import Header from "./Header";
import { CustomButton } from "components/General/CustomButton";
import { useTranslation } from "next-i18next";
import MainLoader from "components/General/Loader/MainLoader";
const Loader = dynamic(() => import("components/General/Loader"), {
  ssr: false,
});
const Footer = dynamic(() => import("./Footer"), {
  ssr: false,
});
const NoItem = dynamic(() => import("components/General/NoItem"));

const MainLayout = ({ Component, pageProps }: any) => {
  const [isOnline, setIsOnline] = useState(true);

  const router = useRouter();
  const isCRDC: boolean = router.pathname.includes("research"); //route is on research

  const { ready } = useTranslation("common", { useSuspense: true });

  //------------------------------------------check online---------------------------------------------

  useEffect(() => {
    setIsOnline(window?.navigator?.onLine);
  }, []);

  //-------------------------------------------notif end--------------------------------------------------

  return (
    <>
      <Loader />

      <Head>
        <meta name="viewport" content="width=device-width,height=device-height,initial-scale=1" />

        <link rel="preconnect" href="/fonts/vazir/Vazir-FD-WOL.ttf" as="font" crossOrigin="" />
      </Head>

      {!isOnline ? (
        <div className="my-6 flex flex-col items-center justify-center">
          <NoItem text="اتصال به اینترنت برقرار نمی باشد" />
          <div className="is-flex-direction-column items-center ">
            <CustomButton
              onClick={() => {
                router.reload();
              }}
            >
              تلاش دوباره
            </CustomButton>
          </div>
        </div>
      ) : ready ? (
        <div className={`flex min-h-[100vh] flex-col`}>
          <Header isCRDC={isCRDC} />

          <main
            className={`${
              router.pathname === "/"
                ? "mt-[66px] md:mt-[160px]"
                : "mt-[78px] min-h-[20rem] md:mt-[160px]"
            }`}
          >
            <Component isCRDC={isCRDC} {...pageProps} />
          </main>

          <Footer isCRDC={isCRDC} />
        </div>
      ) : (
        <MainLoader isLoading={!ready} />
      )}
    </>
  );
};

export default MainLayout;
